import { render, staticRenderFns } from "./AddSurveyQuestion.vue?vue&type=template&id=06930e33&scoped=true"
import script from "./AddSurveyQuestion.vue?vue&type=script&lang=ts"
export * from "./AddSurveyQuestion.vue?vue&type=script&lang=ts"
import style0 from "./AddSurveyQuestion.vue?vue&type=style&index=0&id=06930e33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06930e33",
  null
  
)

export default component.exports